import * as React from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import LoginDetail from "./loginDetail";

class LoginPageComponent extends React.Component {
	state = {
		isForgotPasswordPage: false,
		isLogout: false,
		message: ""
	}
	constructor(props: any) {
		super(props);
		var logoutkey = window.localStorage.getItem('isLoggedoutbyclient');
		var isLog = false;
		var message = "";
		if (logoutkey === "yes") {
			window.localStorage.setItem('isLoggedoutbyclient', "");
			isLog = true;
			message = "You have been logged out.";
		}else if(logoutkey === "auto") {
			window.localStorage.setItem('isLoggedoutbyclient', "");
			isLog = true;
			message = "Session has expired. Please login";
		}
		this.state = {
			isForgotPasswordPage: false,
			isLogout: isLog,
			message: message
		}
		this.handleCallBack = this.handleCallBack.bind(this);
	}
	
	handleCallBack(value) {
		if (value === "forgotPassword") {
			this.setState({ isForgotPasswordPage: true });
		}
	}
	render() {
		const { isForgotPasswordPage, isLogout, message } = this.state;
		return (
			<div className="App">
				<Container>
					{isLogout && !isForgotPasswordPage && (
						<div className="alert alert-dismissible alert-warning al-logout" data-testid="logoutMessageContainer">
							<p className="mb-0"><h4>{message}</h4></p>
						</div>
					)}
					<Row>
						<Col />
						<Col lg="8">
							<div className="jumbotron">
								{!isForgotPasswordPage && (
									<h2 className="center" data-testid="loginPageTitle">
										Login to DAB
									</h2>
								)}
								{isForgotPasswordPage && (
									<h2 className="center" data-testid="forgotPasswordPageTitle">
										Forgot Password
									</h2>
								)}
								<Card>
									<CardBody>
										<LoginDetail callback={this.handleCallBack} />
									</CardBody>
								</Card>
							</div>
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default LoginPageComponent;